import { type DropdownOption } from '../../components/Dropdown';

type SubNode = {
  accountId: string | null,
  id: string,
  name: string,
  children: SubNode[],
  users: string[],
};

type RootNodeParent = {
  accountId: string,
  rootNode: SubNode,
};

//this is called re
export const flattenGetAccountOrgNodesResponse = (
  orgNode: RootNodeParent | SubNode,
  level: number = 0,
): DropdownOption<string>[] => {
  //just to have SOME cap on the max depth to recurse
  if (level > 100) {
    throw new Error('Recursion too deep flattening orgList');
  }
  const orgSubList: DropdownOption<string>[] = [];
    const orgNodeItem: SubNode = 'rootNode' in orgNode ? orgNode.rootNode : orgNode;
    const { id, name } = orgNodeItem;
    //this String.fromCharCode(8194) is an "Em Space" to indent heirarchical org options
    orgSubList.push({
      value: id,
      text: String.fromCharCode(8195).repeat(level) + name,
    });

    if (orgNodeItem?.children?.length) {
      orgNodeItem.children.forEach(item => {
        orgSubList.push(...flattenGetAccountOrgNodesResponse(item, level + 1));
      });
    }
    return orgSubList;
};
